import { Outlet } from "react-router"
import {
    PilotTrackingNestedSidebarContextProvider,
    usePilotTrackingNestedSidebarContext,
} from "panels/pilot-tracking/NestedSidebars"
import { RouteNode } from "@nova/react-router"
import { FlightsPage } from "features/pilot-tracking/flights-page/PilotTrackingFlightsPage"
import { AircraftPage } from "./PilotTracking/AircraftPage"
import { AircraftsPage } from "./PilotTracking/AircraftsPage"
import { ChecklistsPage } from "./PilotTracking/ChecklistsPage"
import { CurrencyPage } from "./PilotTracking/CurrencyPage"
import { CreateCurrencyPolicyPage } from "./PilotTracking/CreateCurrencyPolicyPage"
import { EditCurrencyPolicyPage } from "./PilotTracking/EditCurrencyPolicyPage"
import { CreateChecklistPage } from "./PilotTracking/CreateChecklistsPage"
import { CreateMaintenanceTemplatePage } from "./PilotTracking/CreateMaintenanceTemplatePage"
import { UpdateMaintenanceTemplatePage } from "./PilotTracking/UpdateMaintenanceTemplatePage"
import { MaintenancePage } from "./PilotTracking/MaintenancePage"
import { MissionPage } from "./PilotTracking/MissionPage"
import { PilotPage } from "./PilotTracking/PilotPage"
import { PilotsPage } from "./PilotTracking/PilotsPage"
import { ReportsPage } from "./PilotTracking/ReportsPage"
import { CreateReportTemplatePage } from "./PilotTracking/CreateReportTemplatePage"
import { EditReportTemplatePage } from "./PilotTracking/EditReportTemplatePage"
import { ChecklistDetailsPage } from "./PilotTracking/ChecklistDetailsPage"
import { GenerateReportPage } from "./PilotTracking/GenerateReportPage"
import { PilotTrackingDashboard } from "./PilotTracking/PilotTrackingDashboard"
import { PilotTrackingConnectionsProvider } from "features/data-management/pilot-tracking/PilotTrackingConnectionsContext"

export const FleetWrapper = () => {
    return (
        <PilotTrackingConnectionsProvider>
            <PilotTrackingNestedSidebarContextProvider>
                <FleetWrapperWithContext />
            </PilotTrackingNestedSidebarContextProvider>
        </PilotTrackingConnectionsProvider>
    )
}
const FleetWrapperWithContext = () => {
    const { Sidebar } = usePilotTrackingNestedSidebarContext()
    return (
        <div className="flex h-full">
            <Sidebar />
            <div className="grow flex justify-center min-w-0">
                <Outlet />
            </div>
        </div>
    )
}

export const fleetRouteNode = {
    component: FleetWrapper,
    index: PilotTrackingDashboard,
    children: {
        flights: {
            component: Outlet,
            index: FlightsPage,
            children: {
                missionId: {
                    param: true,
                    component: MissionPage,
                },
            },
        },
        pilots: {
            component: Outlet,
            index: PilotsPage,
            children: {
                currency: {
                    component: Outlet,
                    index: CurrencyPage,
                    children: {
                        create: { component: CreateCurrencyPolicyPage },
                        policyId: {
                            param: true,
                            component: EditCurrencyPolicyPage,
                        },
                    },
                },
                pilotId: {
                    param: true,
                    component: PilotPage,
                },
            },
        },
        aircraft: {
            component: Outlet,
            index: AircraftsPage,
            children: {
                aircraftId: {
                    param: true,
                    component: AircraftPage,
                },
            },
        },
        checklists: {
            component: Outlet,
            index: ChecklistsPage,
            children: {
                create: { component: CreateChecklistPage },
                checklistId: { param: true, component: ChecklistDetailsPage },
            },
        },
        reports: {
            component: Outlet,
            index: ReportsPage,
            children: {
                create: { component: CreateReportTemplatePage },
                update: {
                    children: {
                        reportTemplateId: {
                            param: true,
                            component: EditReportTemplatePage,
                        },
                    },
                },
                generate: { component: GenerateReportPage },
            },
        },
        maintenance: {
            component: Outlet,
            index: MaintenancePage,
            children: {
                template: {
                    component: Outlet,
                    children: {
                        create: { component: CreateMaintenanceTemplatePage },
                        templateId: {
                            param: true,
                            component: UpdateMaintenanceTemplatePage,
                        },
                    },
                },
            },
        },
    },
} satisfies RouteNode
